import { get, post } from '@/app/core/request';
import { CommuneRoutes } from '@/app/api-routes';
import CommuneProjection from '@/types/projections/CommuneProjection';
import BIObject from '@/types/taxcard/BIObject';
import PriceDiscountOptionProjection from '@/types/projections/PriceDiscountOptionProjection';
import AnnualCandidateProjection from '@/types/projections/AnnualCandidateProjection';
import CommuneInfoProjection from '@/types/projections/CommuneInfoProjection';

class CommuneApi {
  async getCommuneList(): Promise<CommuneProjection[]> {
    return get<CommuneProjection[]>(CommuneRoutes.commune);
  }
  async getCommune(id: number): Promise<CommuneProjection> {
    return get<CommuneProjection>(CommuneRoutes.communeById(String(id)));
  }
  async getCommuneDetails(communeId: number, customerUUID: string): Promise<CommuneInfoProjection> {
    return get<CommuneInfoProjection>(CommuneRoutes.communeDetails(communeId, customerUUID));
  }
  async getCommuneDiscountsForTaxcard(communeId: number, bIObject: BIObject): Promise<PriceDiscountOptionProjection[]> {
    const { errors, ...taxcardData } = bIObject.bIObjectData;
    return post<PriceDiscountOptionProjection[]>(
      CommuneRoutes.discountForTaxcard(String(communeId)),
      taxcardData as any
    );
  }
  async getAnnualCandidateStatus(communeId: number, bIObject: BIObject): Promise<AnnualCandidateProjection> {
    const { errors, ...taxcardData } = bIObject.bIObjectData;
    return post<AnnualCandidateProjection>(
      CommuneRoutes.annualCandidateStatusForTaxcard(String(communeId)),
      taxcardData as any
    );
  }
  async findCommuneByCoordinate(latitude: string, longitude: string): Promise<{ communeId: number }> {
    return get<{ communeId: number }>(CommuneRoutes.findCommuneByCoordinates(latitude, longitude));
  }
  async getCommuneAccepts(communeId: number, acceptsId: number): Promise<boolean> {
    return get<{ accepted: boolean }>(CommuneRoutes.communeAccepts(communeId, acceptsId)).then(
      ({ accepted }) => accepted
    );
  }
  async getAcceptedCommunes(byCommuneId: number): Promise<CommuneProjection[]> {
    return get<CommuneProjection[]>(CommuneRoutes.acceptedCommunes(byCommuneId));
  }
  async cancelTransaction(
    id: number,
    customerUUID: string,
    stayBegin: string,
    stayEnd: string,
    cancellationDocument: string,
    cancellationIban: string
  ) {
    return post<any>(CommuneRoutes.cancelTransaction(id, customerUUID), {
      stayBegin,
      stayEnd,
      cancellationDocument,
      cancellationIban,
    });
  }
}

export default new CommuneApi();
